import Cookies from 'js-cookie'
import { on } from 'delegated-events'

const setCookie = (state) => {
  Cookies.set('widgetstate', state, {
    expires: 1,
  })
}

const widget = document.querySelector('.site-widget')

const fn = {
  init: () => {
    on('click', '.close', fn.handleClose)
    if (Cookies.get('widgetstate') === 'closed') {
      widget.style.display = 'none'
    }
    else {
      widget.style.display = 'block'
    }
  },

  handleClose: () => {
    widget.style.display = 'none'
    setCookie('closed')
  },
}

export default {
  can: () => widget,
  run: fn.init,
}
